import { DeskAssignment } from 'client/api/backend/schemas';
import { registerToolkitObjectType } from 'client/components/toolkit/objects/registerToolkitObjectType';

export const AssignmentToolkitObject =
  registerToolkitObjectType<DeskAssignment>('assignment');
